import React from 'react';

import {Loader, Skeleton} from '@optimaxdev/design-system';

import {useFeature} from 'components/feature';

import s from './paymentsLoader.scss';

/**
 * PaymentsLoader render skeleton or spinner
 */
export const PaymentsLoader = () => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <>
            {isFacelift ? (
                <div aria-label="loader skeleton" className={s.wrapper}>
                    <Skeleton className={s.bigSkeleton} height="100%" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                    <Skeleton height="68px" radius="8px" />
                </div>
            ) : (
                <div className={s.loaderWrap}>
                    <Loader className={s.loader} />
                </div>
            )}
        </>
    );
};
